import { atom } from 'jotai';
import { RESET, atomWithStorage } from 'jotai/utils';


const causeKey = 'onboarding-cause';
const referralKey = 'onboarding-referral';
const referralCauseKey = 'onboarding-referral-cause';


// These all start off as undefined before they are loaded. 
// We can leverage this by setting the default to null so we can tell if they have been loaded before in some places. 
export const onboardingCauseAtom = atomWithStorage<undefined | null | string>(causeKey, null);
export const onboardingReferralAtom = atomWithStorage<undefined | null | string>(referralKey, null);
export const onboardingReferralCauseAtom = atomWithStorage<undefined | null | string>(referralCauseKey, null);
export const resetOnboardingAtoms = atom(
  null, // it's a convention to pass `null` for the first argument
  (_, set) => {
    // `update` is any single value we receive for updating this atom
    set(onboardingCauseAtom, RESET);
    set(onboardingReferralAtom, RESET);
    set(onboardingReferralCauseAtom, RESET);
  }
);
resetOnboardingAtoms.debugLabel = 'resetOnboardingAtoms';